<!-- This is part of outdated page https://usd.textbooksatcost.com/service/help_desk.php > "Selling questions" -->
<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Do you offer special tools for volume sellers?</h1>

			<ul>
				<li>
					Yes! We have many exciting tools and special rules for volume sellers.
				</li>
				<li>
					Please email us at <a class="help-link" title="Email" href="mailto:volumeseller@akademos.com">volumeseller@akademos.com</a>
				</li>
			</ul>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "VolumeSellers",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>
